import { GoblinGameObject } from "@game/gameObjects/goblin/goblinGameObject";
import { CharacterGameObject } from "@game/gameObjects/player/character.gameObject";
import { OtherPlayerGameObject } from "@game/gameObjects/player/otherPlayer.gameObject";
import { SelfPlayerGameObject } from "@game/gameObjects/player/selfPlayer.gameObject";
import { MMOCreature, isMMOCreature } from "@game/models/mmoCreature";
import { isFriendly } from "mmo-common";
import { GameObject, System, vector3DistanceToSqred } from "realms-engine";

export class MMOCreatureSystem extends System {
  systemName: string = "MMOCreatureSystem";

  private mmoCreatures = new Set<MMOCreature>();

  constructor() {
    super([
      GoblinGameObject,
      CharacterGameObject,
      SelfPlayerGameObject,
      OtherPlayerGameObject,
    ]);
  }

  /**
   * Returns the closest hostile creature to yourself
   */
  getClosestHostileCreature(selfPlayer: SelfPlayerGameObject) {
    const selfHostility = selfPlayer.getHostility();
    let closestHostileCreature: MMOCreature | null = null;
    let closestDistanceSqred: number | null = null;
    for (const creature of this.mmoCreatures.values()) {
      // Friendly so skip
      if (isFriendly(selfHostility, creature.getHostility())) {
        continue;
      }
      // Ignore yourself
      if (creature === selfPlayer) {
        continue;
      }
      // Ignore dead creatures
      if (creature.isDead()) {
        continue;
      }
      const distSqred = vector3DistanceToSqred(
        selfPlayer.getPosition(),
        creature.getPosition()
      );
      if (closestHostileCreature === null) {
        closestHostileCreature = creature;
        closestDistanceSqred = distSqred;
        continue;
      }
      if (closestDistanceSqred !== null && distSqred < closestDistanceSqred) {
        closestHostileCreature = creature;
        closestDistanceSqred = distSqred;
        continue;
      }
    }
    return closestHostileCreature;
  }

  onTargetGameObjectEnter(gameObject: GameObject<any>): void {
    if (!isMMOCreature(gameObject)) {
      return;
    }
    this.mmoCreatures.add(gameObject);
  }

  onTargetGameObjectExit(gameObject: GameObject<any>): void {
    if (!isMMOCreature(gameObject)) {
      return;
    }
    this.mmoCreatures.delete(gameObject);
  }
}
